"use client";

import React, { lazy, Suspense, useState, useEffect } from "react";
import { getCars, deleteCar } from "../../components/http";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../components/PopUps/ConfirmDeleteButton";
import styles from "../../components/TableTemplate/TableTemplate.module.scss";

import useNavigator from "../../components/navigator/navigator";

const Header = lazy(() => import("../../components/header/header"));
const TableTemplate = lazy(() => import("../../components/TableTemplate/TableTemplate"));
const Pagination = lazy(() => import("../../components/Pagination/Pagination"));
const CarAddPopup = lazy(() => import("./CarAddPopup"));

const CarsPage = () => {
  const { t } = useTranslation("");
  const [cars, setCars] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const limit = 10;
  const navigate = useNavigator(); 

  const fetchCars = async (page) => {
    setisLoading(true)
    try {
      const offset = (page - 1) * limit;
      const response = await getCars(limit, offset);
      setCars(response.data || []);
      setTotalRecords(response.total_count || 0);
      setisLoading(false)
    } catch (error) {
      console.error("Error fetching cars:", error);
    }
  };

  useEffect(() => {
    fetchCars(currentPage);
  }, [currentPage]);


  const handlePopupClose = () => {
    setIsPopupOpen(false);
    fetchCars(currentPage);
  };

  const headers = [
    t("car.List.manufacturer"),
    t("car.List.model"),
    t("car.List.regNumber"),
    t("car.List.year"),
    t("car.List.mileage"),
    t("car.List.client"),
  ];
  const renderRow = (car) => {
    
    return (
      <>
        <div onClick={()=>navigate(`/cars/${car.id}`)} className={styles.hyperLink} data-label={headers[0]}>{car.manufacturer || t("car.List.notSpecified")}</div>
        <div onClick={()=>navigate(`/cars/${car.id}`)} className={styles.hyperLink} data-label={headers[1]}>{car.model || t("car.List.notSpecified")}</div>
        <div className={styles.cell} data-label={headers[2]}>{car.reg_number || t("car.List.notSpecified")}</div>
        <div className={styles.cell} data-label={headers[3]}>{car.year || t("car.List.notSpecified")}</div>
        <div className={styles.cell} data-label={headers[4]}>{car.mileage ? `${car.mileage} км` : t("car.List.notSpecified")}</div>
        <div onClick={()=>navigate(`/clients/client/${car.client?.id}`)} className={styles.hyperLink} data-label={headers[5]}>{car.client?.fullname || t("car.List.withoutClient")}</div>
      </>
        
    );
  };
  

  return (
    <Suspense fallback={<div>{t("loading")}</div>}>
      <Header 
        title={t("car.List.title")} 
        onAddClick={() => setIsPopupOpen(true)}
        showImportExport={false}
        onImportClick={null}
        onExportClick={null}
      />
      <TableTemplate
        data={cars}
        renderRow={renderRow}
        title={t("car.List.title")}
        isLoading ={isLoading}
        headers={headers}
        path="/cars"
      />
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalRecords / limit)}
        onPageChange={(page) => setCurrentPage(page)}
      />
      {isPopupOpen && (
        <CarAddPopup
          open={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          onCarAdded={handlePopupClose}
        />
      )}
    </Suspense>
  );
};

export default CarsPage;
